import { Injectable, EventEmitter } from '@angular/core';

const BOTTOM_PANEL_HEIGHT: number = 300;

@Injectable()
export class BottomPanelService {

  private isOpenState;
  private bottomPanelOpened = new EventEmitter<boolean>();

  getBottomPanelOpenEvent() {
    return this.bottomPanelOpened.asObservable();
  }

  isOpened() {
    return this.isOpenState;
  }

  getBottomPanelHeightInPixels(): number {
    return BOTTOM_PANEL_HEIGHT;
  }

  openBottomPanel() {
    this.bottomPanelOpened.emit(true);
    this.isOpenState = true;
  }

  closeBottomPanel() {
    this.bottomPanelOpened.emit(false);
    this.isOpenState = false;
  }

  toggleBottomPanel() {
    this.isOpenState = !this.isOpenState;
    this.bottomPanelOpened.emit(this.isOpenState);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/bottom-panel/bottom-panel.service.ts